module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAUEAAAFGAgMAAACJZcUaAAAACVBMVEX///8AAAD///9+749PAAAAA3RSTlMaAA2Vdp7FAAABPElEQVR42u3dsU3DYBSF0RdLKUKfEVywxT9CisRymZIxvIR7RgXHBOi5EbF07gBHegu8ry7Lhvf6817mG9VWcarAul/iqSJ7/RaHyqyb7+JYofV3cUqJ3Zc4VGzzKo45cb+KLSfuVrGCu4lDUjwu4pgU+0W8JsXDIrakuFvEKSl2n+JQ0c1x8djqnBX7VmNcPGXFfatrVjy0allx9whxyordNsT0iEQikUgkEolEIpFIJBKJRCKRSCQSiUQikUgkEolEIpFIJBKJRCKRSCQSiUQikUgkEolEIpFIJBKJRCKRSCQSiUQikUgkEolEIpFI/B9xenZxI5+Lt/BTOv9JO//tO/+R/Pzs4rHVJSvO8Q/5+S/++dJAvoaQLzbEqxL58kW+zpEviMQrJ48qsQTP/inavCWLNvnqTr4M9AEwZZv6y2K3+AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/images/buy_more/chance_bg.png
// module id = MObM
// module chunks = 1